import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ButtonModule } from '@components/button';
import { CsIconModule } from '@components/icon';
import { SkinReportSheetComponent } from './skin-report-sheet.component';

@NgModule({
  imports: [
    CommonModule,
    ButtonModule,
    CsIconModule,
    FormsModule,
  ],
  declarations: [SkinReportSheetComponent],
  exports: [SkinReportSheetComponent],
})
export class SkinReportSheetModule { }
